module.exports = "/newsfeed/components/newsfeed-page-widgets-96d9a8.html";